import React from 'react';
import { Alert, Button, Result, Table, Tabs } from 'antd';
import { BotFillStage } from './types';
import { useBotFillConfig } from './queries';

const labels: Record<BotFillStage, string> = { normal: 'Normal', grace_period: 'Grace Period', easy_win: 'Easy Win' };
const errorText = (error: unknown) => error instanceof Error ? error.message : 'Request failed';

function StageConfig({ stage }: { stage: BotFillStage }) {
  const query = useBotFillConfig(stage);
  if (query.error) return <Result status="error" title="Failed to load bot fill configuration" subTitle={errorText(query.error)} extra={<Button onClick={() => query.refetch()}>Retry</Button>} />;
  return <>
    <div className="mb-4"><Button loading={query.isFetching} onClick={() => query.refetch()}>Refresh</Button></div>
    <Table rowKey={(_, index) => String(index)} loading={query.isLoading} dataSource={query.data?.brackets || []} pagination={false} scroll={{ x: 650 }} columns={[
      { title: 'Elo min (inclusive)', dataIndex: 'elo_min', render: value => value ?? 'No lower bound' },
      { title: 'Elo max (inclusive)', dataIndex: 'elo_max', render: value => value ?? 'No upper bound' },
      { title: 'Easy %', dataIndex: 'easy_pct' }, { title: 'Medium %', dataIndex: 'medium_pct' }, { title: 'Hard %', dataIndex: 'hard_pct' },
    ]} />
  </>;
}
export const BotFillConfigPage: React.FC = () => <>
  <Alert type="info" showIcon className="mb-4" message="Elo outside the configured range uses the existing Medium fallback." />
  <Tabs items={(Object.keys(labels) as BotFillStage[]).map(stage => ({ key: stage, label: labels[stage], children: <StageConfig stage={stage} /> }))} />
</>;
